export default {
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  setMenus(state, menus) {
    state.menus = menus;
  },
  setLevel1CurrentIndex(state, index) {
    state.level1CurrentIndex = index;
  },
  setProvinceList(state, provinceList) {
    state.provinceList = provinceList;
  },
  setCityList(state, cityList) {
    state.cityList = cityList;
  }
};
